import { Outlet, createFileRoute } from "@tanstack/react-router";

import { enterpriseOriginCrumb } from "@/lib/crumb-resolvers";
import { requireRole } from "@/lib/route-guards";

// crumb は出自 L1 (ダッシュボード / 承認待ち / 承認後案件 / 応募管理) に応じて切り替える。
// 案件詳細はこの layout 直下に固定なので、放置すると常に「ダッシュボード」になってしまう。
// L1 一覧ページ自身では AutoBreadcrumb が非表示にするので、分岐は案件詳細でのみ効く。
export const Route = createFileRoute("/_authenticated/enterprise")({
  staticData: { crumb: enterpriseOriginCrumb() },
  beforeLoad: requireRole("ENTERPRISE"),
  component: () => <Outlet />,
});
